import { render, staticRenderFns } from "./orderTuiList.vue?vue&type=template&id=34a14b0c&scoped=true&"
import script from "./orderTuiList.vue?vue&type=script&lang=js&"
export * from "./orderTuiList.vue?vue&type=script&lang=js&"
import style0 from "./orderTuiList.vue?vue&type=style&index=0&id=34a14b0c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a14b0c",
  null
  
)

export default component.exports